export default __webpack_public_path__ + "static/11-13fd50ad579f079d337b61b669fd7d24.png";